import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';
// import {Table} from 'antd'
// import { Checkbox } from 'antd';

import './Drawings.scss';

export default class ProcurementHistoryGrid extends React.PureComponent {
  static propTypes = {
    drawings: PropTypes.array.isRequired,
    downloadSelected: PropTypes.func.isRequired,
  };

  /*
  state = { selected: {}, selectAll: 0, data: this.props.drawings };

  toggleRow(drawingNo) {
    const newSelected = { ...this.state.selected };
    if (newSelected[drawingNo]) {
      newSelected[drawingNo] = !this.state.selected[drawingNo];
      if (!newSelected[drawingNo]) {
        delete newSelected[drawingNo];
      }
    } else {
      newSelected[drawingNo] = true;
    }

    const showButton = Object.keys(newSelected).length === 0 ? 0 : 2;
    this.setState(
      {
        selected: newSelected,
        selectAll: showButton,
      },
      () => {
        if (this.state.selectAll === 0) this.props.downloadSelected(false);
        else this.props.downloadSelected(true);
      },
    );
  }

  toggleSelectAll() {
    const newSelected = {};

    if (this.state.selectAll === 0) {
      this.state.data.forEach(x => {
        newSelected[x.drawingNo] = true;
      });
    }

    this.setState(
      {
        selected: newSelected,
        selectAll: this.state.selectAll === 0 ? 1 : 0,
      },
      () => {
        if (this.state.selectAll === 0) this.props.downloadSelected(false);
        else this.props.downloadSelected(true);
      },
    );
  }

  */

  render() {
    const { drawings } = this.props;
    this.props.downloadSelected(true);
    const columns = [
      /*
      {
        id: 'checkbox',
        accessor: '',
        Cell: cellProps => (
          <Checkbox
            checked={this.state.selected[cellProps.original.drawingNo] === true}
            onChange={() => this.toggleRow(cellProps.original.drawingNo)}
          />
        ),
        Header: () => (
          <Checkbox
            checked={this.state.selectAll === 1}
            indeterminate={this.state.selectAll === 2}
            onChange={() => this.toggleSelectAll()}
          />
          // <Checkbox
          //   checked={this.state.selectAll === 1}
          //   ref={input => {
          //     if (input) {
          //       input.indeterminate = this.state.selectAll === 2;
          //     }
          //   }}
          //   onChange={() => this.toggleSelectAll()}
          // />
        ),
        sortable: false,
        width: 30,
      },
*/
      {
        Header: 'Drawing No.',
        accessor: 'drawingNo',
      },
      {
        Header: 'CAGE',
        accessor: 'cage',
      },
      {
        Header: 'Type',
        accessor: 'type',
      },
      {
        Header: 'Data Type',
        accessor: 'docDataCd',
      },
      {
        Header: 'Doc Date',
        accessor: 'docDate',
      },
      {
        Header: 'Rev',
        accessor: 'rev',
      },
      {
        Header: 'Rev Date',
        accessor: 'revDate',
      },
      /*
      {
        Header: 'Lic Agmt',
        accessor: 'licAgmt',
      },
      {
        Header: 'Export Ctrl',
        accessor: 'exportCtrl',
      },
      {
        Header: 'Fgn Secure',
        accessor: 'fgnSecure',
      },
      {
        Header: 'Files',
        accessor: 'files',
      },
      {
        Header: 'Title',
        accessor: 'title',
      },
      */
      {
        Header: 'Ty No',
        accessor: 'tyNo',
      },
    ];
    return (
      <div className="nf-drawings__grid">
        <ReactTable
          data={drawings}
          columns={columns}
          defaultPageSize={drawings.length < 5 ? drawings.length : 5}
          showPagination={drawings.length > 5}
          style={{ textAlign: 'center' }}
        />
        {/* <Table dataSource={drawings} columns={columns} /> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/DrawingsGrid/DrawingsGrid.jsx